/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Siempre queremos transmitir información de componentes padres a componentes hijos para separar las responsabilidades y para tener un código mucho más modular y más legible.`}</p>
    <p>{`Dentro de la Pokédex debemos de pasar los datos que nos devuelve la API, así como el estado de carga y error para que `}<inlineCode parentName="p">{`<PokedexScreen />`}</inlineCode>{` muestre la información necesaria.`}</p>
    <p>{`Dentro de todos los snippets de código encontrarás un `}<strong parentName="p"><inlineCode parentName="strong">{`ul`}</inlineCode>{` vacío`}</strong>{` donde en la siguiente sección iteraremos sobre la lista de estadísticas de los pokémones.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;